import { createTheme } from "@mui/material/styles";
import { blue, green } from "@mui/material/colors";

export const colors = {
  grey: {
    100: "#e3e2e1",
    300: "#777675"
  },
};

const theme = createTheme({
  palette: {
    primary: {
      main: blue[900],
    },
    secondary: {
      main: green[500],
    },
  },
});

export default theme;
